module.exports = __webpack_public_path__ + "media/addons/VIPMembership-8c70fb66.svg";